<template>
    <div class="container-fluid">
        <div class="container-fluid" v-if="activePageCRU==0">
            <div class="row mb-1">
              <div class="col-sm pb-1 text-start">
                <span class="badge rounded-pill  text-danger pull-left mt-1 py-2 px-4" style="font-size:18px; background:#ffc6b3;">
                    <b>Receive Payment : รับชำระเงิน</b>
                </span>
                <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการใบสั่งตรวจใหม่">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox0" value="0" v-model="status0New">
                  <label class="form-check-label" for="inlineCheckbox0"><b>New</b> </label>
                </div>
                <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่รับเข้าห้องแล็บ">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="1" v-model="status1Lab">
                  <label class="form-check-label" for="inlineCheckbox1"><b>Lab</b> </label>
                </div>
                <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่ป้อนผลแล้วรออนุมัติ">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="2" v-model="status2Res">
                  <label class="form-check-label" for="inlineCheckbox2"><b>Resulted</b> </label>
                </div>
                <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่ป้อนผลและอนุมัติแล้ว">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox3" value="3" v-model="status3App">
                  <label class="form-check-label" for="inlineCheckbox3"><b>AP</b> </label>
                    </div>

              </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-8">
                    <div class="row">
                    <div class="col">
                        <!-- สาขาแล็บ -->
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                            <span class="input-group-text" style="width:120px;">สาขา* :</span>
                            </div>
                            <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID">
                                <option disabled value="">Please select one</option>
                                <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col">
                        <!-- วันที่ใบสั่งตรวจ -->
                        <div class="input-group input-group-sm mb-1">
                        <span class="input-group-text" style="width:120px;">วันที่เอกสาร</span>
                        <v-date-picker mode="date" v-model="dateFm" :masks="masks">
                            <template v-slot="{ inputValue, inputEvents }">
                                <input name="dateFm" ref="dateFm" style="width:120px;"
                                class="bg-white border px-2 py-1 rounded"
                                :value="inputValue"
                                v-on="inputEvents"
                                />
                            </template>
                        </v-date-picker>
                        <v-date-picker mode="date" v-model="dateTo" :masks="masks">
                            <template v-slot="{ inputValue, inputEvents }">
                                <input name="dateTo" ref="dateTo" style="width:120px;"
                                class="bg-white border px-2 py-1 rounded"
                                :value="inputValue"
                                v-on="inputEvents"
                                />
                            </template>
                        </v-date-picker>
                        <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="col-sm">
                  <!-- <button type="button" class="btn btn-primary btn-sm text-white float-end mx-2"
                    style="width:120px;" @click="newRecord()">New</button> -->
                </div>
            </div>
            <!-- ตารางใบสั่งตรวจ สถานะใหม่และป้อนผล ตามเงื่อนไขสาขาและวันที่เอกสาร -->
            <LabPaid1View :datalists="datalists" :key="countRefresh"
                @onEditRecordEvent="editRecord"
                @onBackPageAfterSaveEvent="backPageAfterSave"></LabPaid1View>
        </div>
        <!-- หน้าจอรับชำระเงิน แสดงรายละเอียดเอกสารทั้งหมด -->
        <div class="container-fluid" v-if="activePageCRU==2">
            <LabPaid2Edit
              :rowEdit="curRecord"
              :dataTestSuitlists="dataTestSuitlists"
              :dataCliniclists="dataCliniclists"
              :dataOfficerlists="dataOfficerlists"
              :dataBranchlists="dataBranchlists"
              :dataSpecimenlists="dataSpecimenlists"
              @onBackPageEvent="backPage"
              @onBackPageAfterSaveEvent="backPageAfterSave"></LabPaid2Edit>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import LabCreate1View from './LabCreate1View.vue'
import LabPaid1View from './LabPaid1View.vue'
import LabPaid2Edit from './LabPaid2Edit.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'LabCreate',
  data () {
    return {
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      status0New: false,
      status1Lab: false,
      status2Res: false,
      status3App: true,

      countRefresh: 0,
      activePageCRU: 0, // 0-View or Read/ 1-Create/ 2-Update
      // False : แสดงหน้าจอ View,  True : แสดงหน้าจอป้อนผลแล็บ
      datalists: null,
      curRecord: null,
      PatName: '',
      action: 'new',
      // ชุดตรวจสำหรับแสดงใน Modal เพื่อเลือกใส่ใบสั่งตรวจ
      dataTestSuitlists: null,
      // รายชื่อคลินิกต้นทาง สำหรับเลือกใน Header Table
      dataCliniclists: null,
      // รายชื่อ พนง ในระบบ สำหรับเลือกใน Header Table
      dataOfficerlists: null,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null,
      // รายชื่อ specimen ทั้งหมด
      dataSpecimenlists: null,
      // รายชื่อ ห้องตรวจ ทั้งหมด สำหรับใช้กรองชุดตรวจ ขณะเลือก
      dataRoomtypelists: null
    }
  },
  created () {
    // Initial Value
    // this.getOfficerData()
    // this.getBranchData()
  },
  mounted () {
    this.getTestSuitData()
    this.getClinicData()
    this.getOfficerData()
    this.getBranchData()
    this.getSpecimenData()
    this.getRoomtypeData()

    this.branchID = this.globalBranchID
    // ดึงข้อมูลรายการใบสั่งตรวจ
    this.getData()
  },
  components: {
    LabPaid1View,
    LabPaid2Edit
  },
  methods: {
    getRoomtypeData () {
      MyApiClient.get('getdata/roomtype_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataRoomtypelists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getSpecimenData () {
      MyApiClient.get('getdata/specimen_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataSpecimenlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getOfficerData () {
      MyApiClient.get('getdata/officers_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataOfficerlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // รายชื่อคลินิกต้นทาง สำหรับเลือกใน Header Table
    getClinicData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/clinicreq_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.dataCliniclists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // ชุดตรวจทั้งหมด สำหรับเลือกในใบสั่งตรวจ
    getTestSuitData () {
      // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/testsuits_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataTestSuitlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // Callback หลังจาก "รับชำระเงิน" (LabPaid3Payment)
    backPageAfterSave () {
      // console.log('backPageAfterSave <LabPaid>..')
      this.activePageCRU = 0
      this.$nextTick(() => {
        $('#myLabReqTable').DataTable()
      })
      // ดึงข้อมูลรีเฟรชตารางใบสั่งตรวจ
      this.getData()
    },
    backPage () {
      this.curRecord = {}
      this.action = 'new'
      this.activePageCRU = 0
      this.$nextTick(() => {
        $('#myLabReqTable').DataTable()
      })
    },
    editRecord (row) {
      this.curRecord = row
      this.action = 'edit'
      this.activePageCRU = 2 // 0-View 1-New 2-Edit
    },
    getData () {
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchID
      var Status0 = -1 // 0-New
      var Status1 = -1 // 1-Lab
      var Status2 = -1 // 2-Resulted
      var Status3 = -1 // 3-Approve
      if (this.status0New) {
        Status0 = 0 // 0-New
      }
      if (this.status1Lab) {
        Status1 = 1 // 1-Lab
      }
      if (this.status2Res) {
        Status2 = 2 // 2-Resulted
      }
      if (this.status3App) {
        Status3 = 3 // 3-Approve
      }
      MyApiClient.get('getdata/labrequest_where_payment.php?C1=' + this.globalCorpID +
        '&BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&Status0=' + Status0 + '&Status1=' + Status1 + '&Status2=' + Status2 + '&Status3=' + Status3)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          //   setTimeout(function () { $('#myLabReqTable1').DataTable() }, 0)
          // setTimeout(function () { $('#myLabReqTable').DataTable() }, 0)
          this.$nextTick(() => {
            $('#myLabReqTable').DataTable()
          })
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
